import { Divider, Typography } from "@mui/material";

interface Props {
  label?: string;
}

export const ButtonDivider = ({ label }: Props) => {
  return (
    <div>
      <Divider>
        {label && (
          <Typography
            textTransform={"uppercase"}
            sx={{ color: theme => theme.palette.grey[500] }}
          >
            {label}
          </Typography>
        )}
      </Divider>
    </div>
  );
};
